import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authEvents from "../../services/users/AuthEvents";
import "../../css/SessionExpiredModal.css";

export default function SessionExpiredModal() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = authEvents.subscribe((event) => {
            if (event === "SESSION_EXPIRED") {
                setIsOpen(true);
                document.body.style.overflow = "hidden";
            }
        });

        return () => {
            unsubscribe();
            document.body.style.overflow = "auto";
        };
    }, []);

    const handleOk = () => {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        navigate("/", { replace: true });
    };

    if (!isOpen) return null;

    return (
        <div className="session-modal-overlay">
            <div className="session-modal-content">
                <h2 className="session-modal-title">Sessão Expirada!</h2>
                <p className="session-modal-text">
                    Clique OK para retornar ao login.
                </p>
                <button
                    onClick={handleOk}
                    className="session-modal-button"
                >
                    OK
                </button>
            </div>
        </div>
    );
}
